import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Not allowed',
  description: 'You are not enabled to perform this action',
});
